import {Pagination} from '@primer/react'
import {useSearchParams} from '@github-ui/use-navigate'
import {parsePageNumber} from '../utils/url-helpers'

/**
 * Shared pagination control for offset-paginated lists that only know whether a next page exists.
 * Used by both the task list and automations list.
 */
export function ListPagination({hasNextPage, hidden}: {hasNextPage: boolean; hidden: boolean}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const currentPage = parsePageNumber(searchParams.get('page'))
  const hasPreviousPage = currentPage > 1
  const pageCount = hasNextPage ? currentPage + 1 : currentPage

  const onPageChange = (e: React.MouseEvent, page: number): void => {
    e.preventDefault()
    searchParams.set('page', page.toString())
    setSearchParams(searchParams)
  }

  if (hidden || (!hasNextPage && !hasPreviousPage)) return null
  return <Pagination showPages={false} pageCount={pageCount} currentPage={currentPage} onPageChange={onPageChange} />
}
